import { FormGroup, Text } from '@ksyos/design-system';
import type { IKisSettingAddEditValidated } from '@common/validation/kisSetting';
import { ShowYesNo } from '@frontend/components/elements/common';
import { GroupSectionHeading } from '@frontend/components/elements/GroupSectionHeading';
import { getSelectedLanguage } from '@frontend/translate';

type KisSettingReadProps = {
    kisSetting?: IKisSettingAddEditValidated;
};

export function KisSettingRead(props: Readonly<KisSettingReadProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <GroupSectionHeading sectionName={translate.kisSetting.kisSetting} />
            <FormGroup label={translate.kisSetting.usesKis}>
                <Text>
                    <ShowYesNo value={!!props.kisSetting} />
                </Text>
            </FormGroup>

            {props.kisSetting && (
                <>
                    <FormGroup label={translate.kisSetting.kisType}>
                        <Text>{props.kisSetting.type || '-'}</Text>
                    </FormGroup>

                    <FormGroup label={translate.kisSetting.serverAddress}>
                        <Text>{props.kisSetting.serverAddress || '-'}</Text>
                    </FormGroup>

                    <FormGroup label={translate.kisSetting.serverPort}>
                        <Text>{props.kisSetting.serverPort || '-'}</Text>
                    </FormGroup>

                    <FormGroup label={translate.kisSetting.username}>
                        <Text>{props.kisSetting.username ?? '-'}</Text>
                    </FormGroup>

                    <FormGroup label={translate.common.password}>
                        <Text>{props.kisSetting.password ?? '-'}</Text>
                    </FormGroup>
                </>
            )}
        </>
    );
}
